import { html } from "lit";
import ComponentBase from "../../../common-components/component-base";
import { property } from "lit/decorators";

class ButtonHelperText extends ComponentBase {
  static get tagName() {
    return "button-helper-text";
  }

  @property()
  text: string;

  render() {
    return html`
      <div class="p-2">
        <small>${this.text}</small>
      </div>
    `;
  }
}

ButtonHelperText.Register();
export default ButtonHelperText;
